var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDog406(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#f9f7e1;stroke:#333;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dog_406"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "_406",
    "data-name": 406,
    className: "cls-2",
    d: "M41.53,1.61C55.51-1.1,64.65,16,69.21,28.55c6.17,17.08,12.25,66.65-13,70-25,3.34-34.25-48.75-30-68.62C27.33,24.42,31.74,3.51,41.53,1.61Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDog406);
export default __webpack_public_path__ + "static/media/dog_406.282be3e85bcfe6a932edb3ab5ce04a14.svg";
export { ForwardRef as ReactComponent };